import { differenceInDays } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const singlePageCheckoutMaxWidth = { md: "960px", lg: "1120px" };
export const singlePageCheckoutPaddingLeft = { _: 3, md: 0 } as const;
export const singlePageCheckoutPaddingRight = { _: 3, md: 4 } as const;

export function getDifferenceInDays(
  startDate: Date,
  endDate: Date,
  timezone: string
) {
  const startDateInTimezone = toZonedTime(startDate, timezone);
  const endDateInTimezone = toZonedTime(endDate, timezone);

  return differenceInDays(endDateInTimezone, startDateInTimezone);
}
